import { Request,BaseApiUrl } from "./api";
// 工程模块
// 列表
export const getMatUnitListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatUnit/get`, { params: params });
};
//编辑
export const editMatUnit = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatUnit/put`, params);
};
//新增
export const addMatUnit = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatUnit/post`, params);
};
//批量删除
export const batchDeleteMatUnit = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatUnit/BatchDelete`, params);
};
// export const batchDeleteMatUnit = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/MatUnit/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };